// 공통 CSS 파일을 임포트
import '@/styles/global.css'
// 공통 locale 파일을 임포트
import '@/locales/i18n'

/**
 * gatsby-browser는 브라우저에서만 로드되며 브라우저에서 실행되는 코드를 수정하는 데 사용
 * 일반적인 사용 사례로는 글로벌 스타일 추가, 서비스 워커 등록, 타사 라이브러리 통합 등이 있음.
 */
export const onInitialClientRender = () => {
  window.fbAsyncInit = () => {
    window.FB.init({
      appId: process.env.GATSBY_FACEBOOK_APP_ID,
      xfbml: true,
      version: 'v16.0',
    })
    window.FB.AppEvents.logPageView()
  }

  const loadSDK = (d: Document, s: string, id: string) => {
    const fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    const js = d.createElement(s) as HTMLScriptElement
    js.id = id
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode?.insertBefore(js, fjs)
  }

  loadSDK(document, 'script', 'facebook-jssdk')
}

export { wrapRootElement } from './src/components'

export { wrapPageElement } from './src/components'
